import React, { useState, useEffect } from 'react';
import { Select as AntSelect, SelectProps as SelectProps } from '@vertem-core/vertice-ds';

// ============================================================================
// ESTILOS
// ============================================================================
import {
  SelectWrapper,
  StyledLabel,
  StyledSelect,
} from './Select.styles';

// ============================================================================
// COMPONENTE
// ============================================================================

const Select: React.FC<SelectProps> & { Option: typeof AntSelect.Option } = (props: any) => {
  const [isFocused, setIsFocused] = useState(false);
  const [hasValue, setHasValue] = useState(!!props.value);

  useEffect(() => {
    setHasValue(!!props.value);
  }, [props.value]);

  return (
    <SelectWrapper>
      <StyledLabel isFocused={isFocused} hasValue={hasValue}>
        {props.placeholder}
      </StyledLabel>
      <StyledSelect
        {...props}
        placeholder={undefined}
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
        onChange={(value: any) => {
          setHasValue(!!value);

          if (props.onChange) {
            props.onChange(value);
          }
        }}
        onDropdownVisibleChange={(open: any) => {
          if (!open) setIsFocused(false);
        }}
      />
    </SelectWrapper>
  );
};

Select.Option = AntSelect.Option;

export default Select;
